import { render, staticRenderFns } from "./EditBulk.vue?vue&type=template&id=43643ad2&"
import script from "./EditBulk.vue?vue&type=script&lang=js&"
export * from "./EditBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports